import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from './Img/ThakurCapital.png';
import { fetchData } from './Services/apiService';
import { apiUrl, publicCoursePath } from './config/api';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProgramsOpen, setIsProgramsOpen] = useState(false);
  const [programs, setPrograms] = useState([]);
  const isCoursePage = location.pathname.startsWith('/course');

  const closeNavigation = () => {
    setIsMenuOpen(false);
    setIsProgramsOpen(false);
  };

  useEffect(() => {
    closeNavigation();
  }, [location.pathname]);

  useEffect(() => {
    fetchData(apiUrl('All/Offerings'))
      .then((data) => setPrograms(data || []))
      .catch((error) => console.error('Unable to load navigation programs:', error));
  }, []);

  return (
    <header className="site-header">
      <nav className="site-nav" aria-label="Main navigation">
        <Link className="site-nav__brand" to="/" onClick={closeNavigation} aria-label="Thakur Capital home">
          <img src={logo} alt="Thakur Capital" />
        </Link>

        <button
          className={`site-nav__toggle ${isMenuOpen ? 'is-open' : ''}`}
          type="button"
          aria-expanded={isMenuOpen}
          aria-controls="site-navigation-links"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span /><span /><span />
          <span className="visually-hidden">Toggle navigation</span>
        </button>

        <div className={`site-nav__links ${isMenuOpen ? 'is-open' : ''}`} id="site-navigation-links">
          <Link to="/" className={location.pathname === '/' ? 'is-active' : ''} onClick={closeNavigation}>Home</Link>
          <Link to="/about" className={location.pathname === '/about' ? 'is-active' : ''} onClick={closeNavigation}>About us</Link>

          <div className="site-nav__programs">
            <button
              className={isCoursePage ? 'is-active' : ''}
              type="button"
              aria-expanded={isProgramsOpen}
              aria-controls="programs-menu"
              onClick={() => setIsProgramsOpen((open) => !open)}
            >
              Our programs <span aria-hidden="true">⌄</span>
            </button>
            <div className={`site-nav__program-menu ${isProgramsOpen ? 'is-open' : ''}`} id="programs-menu">
              <span className="site-nav__program-label">Explore programs</span>
              {programs.map((program) => (
                <Link to={publicCoursePath(program.course_type)} key={program.course_type} onClick={closeNavigation}>
                  <strong>{program.title}</strong>
                  <span>{program.menu_subtitle || program.course_type}</span>
                </Link>
              ))}
            </div>
          </div>

          <Link to="/contact" className={location.pathname === '/contact' ? 'is-active' : ''} onClick={closeNavigation}>Contact</Link>
        </div>
      </nav>
    </header>
  );
};

export { Header };
